import { assert } from '../app/logger.js';

/**
 * Message box.
 */
class MessageBox {
  constructor(el) {
    assert(el, `No element to attach MessageBox to`);

    this.msg = el;
    this.msg.innerHTML = `
      <div class='sqbutton close-button' title='Close'></div>
      <div class='msg-body'></div>
    `;
    this.msg.querySelector('.close-button').onclick = () => this.hide();
    this.msgBody = this.msg.querySelector('.msg-body');
  }

  success(html) {
    this.msgBody.innerHTML = html;
    this.msg.classList.remove('error');
    this.msg.classList.add('success');
    this.msg.hidden = false;
    window.scrollTo(0, 0);
  }

  error(html) {
    this.msgBody.innerHTML = html;
    this.msg.classList.remove('success');
    this.msg.classList.add('error');
    this.msg.hidden = false;
    window.scrollTo(0, 0);
  }

  unexpectedError() {
    this.error(
      `Unexpected problem. Please reach us at
      <a href='mailto:support@camperaid.com'>support@camperaid.com</a>`
    );
  }

  hide() {
    this.msg.hidden = true;
  }

  show() {
    this.msg.hidden = false;
  }
}

export { MessageBox };
